import { Grid, Typography } from "@mui/material";
import { AiOutlineDelete } from "react-icons/ai";
import React, { Fragment, useEffect, useState } from "react";

import {
  CommonTextField,
  LoadingButton,
  MandatoryNote,
  SelectField,
  TextField,
} from "../../../../components";
import { useAxios, useComponent } from "../../../../hooks";
import { useSelector } from "react-redux";
import CustomField from "./CustomField";
import { Formik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import * as Yup from "yup";

function Form1({ formik, setStepperLevel, customFields }) {
  const axios = useAxios();
  const { loader } = useComponent();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);

  const [formData, setFormData] = useState({
    visitorData: [
      {
        ID: visitorData.ID,
        name: visitorData.firstName + " " + visitorData.lastName,
        mobile: visitorData.phoneNumber,
      },
    ],
  });

  const generateFieldSchema = (field) => {
    let schema;

    switch (field.value_type) {
      case "string":
        schema = Yup.string();
        if (field.regex) {
          schema = schema.matches(
            new RegExp(field.regex),
            field.error_message || "Invalid format"
          );
        }
        break;

      case "boolean":
        schema = Yup.boolean();
        break;

      case "list":
        schema = Yup.mixed();
        break;

      default:
        schema = Yup.mixed(); // fallback
    }

    if (field.mandatory) {
      schema = schema.required(
        field.error_message || `${field.label} is required`
      );
    }

    return schema;
  };

  const dynamicVisitorSchemaShape = {};

  customFields.forEach((field) => {
    dynamicVisitorSchemaShape[field.name] = generateFieldSchema(field);
  });

  var validationSchema = Yup.object().shape({
    visitorData: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Name is requied"),
        mobile: Yup.string()
          .matches(/^\+?[1-9]\d{1,14}$/, "Invalid phone number format")
          .required("Phone number is required"),
        ...dynamicVisitorSchemaShape,
      })
    ),
  });

  useEffect(() => {
    loader.start();
    axios({
      url: "event/booking/states",
      method: "GET",
    })
      .then((response) => {
        if (response.status) {
          setStateOptions(response.data);
        }
        loader.apiComplete();
      })
      .catch((error) => {
        console.error("Error in fetching states list", error);
      });
  }, []);

  return (
    <Fragment>
      <Formik
        initialValues={formData}
        // validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(formData) => {
          formik.setValues((prev) => ({
            ...prev,
            ...formData,
          }));
          setStepperLevel(2);
        }}
      >
        {(formikProps) => {
          console.log(formik, "formik");
          console.log(formikProps, "formikProps");

          return (
            <Fragment>
              <Grid container>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    textTransform: "capitalize",
                    padding: "15px 15px 20px 5px !important",
                    borderRadius: "12.5px",
                    position: "relative",
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "900", marginBottom: "15px" }}
                    >
                      Your Mobile No{"  "}
                      <span
                        style={{
                          color: "red",
                          "-webkit-text-stroke-width": ".5px",
                        }}
                      >
                        *
                      </span>
                    </Typography>

                    <TextField
                      name={`visitorData[${0}].mobile`}
                      placeholder={"Mobile No"}
                      formikProps={formikProps}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "900", marginBottom: "7.5px" }}
                    >
                      Your Name{"  "}
                      <span
                        style={{
                          color: "red",
                          "-webkit-text-stroke-width": ".5px",
                        }}
                      >
                        *
                      </span>
                    </Typography>

                    <TextField
                      name={`visitorData[${0}].name`}
                      placeholder={"Name"}
                      required
                      disabled={visitorData.firstName}
                      formikProps={formikProps}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <CustomField
                    title={true}
                    visitorDataIndex={0}
                    formikProps={formikProps}
                    customFields={customFields}
                  />
                </Grid>
              </Grid>

              {/* <Grid
                item
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "5px",
                }}
              >
                <div
                  style={{
                    margin: "5px",
                    // border: "1px solid black",
                    padding: "10px 20px",
                    borderRadius: "12.5px",
                  }}
                >
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 900,
                        textAlign: "start",
                      }}
                    >
                      Add Members
                    </Typography>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        // padding: "10px 20px",
                        // border: "1px solid black",
                        // borderRadius: "12.5px",
                      }}
                    >
                      <RemoveIcon
                        sx={{
                          margin: "0px 10px",
                          borderRadius: "5px",
                          border: "1px solid black",
                        }}
                        onClick={() => {
                          formik.values.memberCount > 0 &&
                            formik.setFieldValue(
                              "memberCount",
                              formik.values.memberCount - 1
                            );
                        }}
                      />
                      <Typography
                        sx={{
                          fontWeight: 900,
                          textAlign: "start",
                          color: "rgb(57, 54, 239)",
                        }}
                      >
                        {formik.values.memberCount || 0}
                      </Typography>
                      <AddIcon
                        sx={{
                          margin: "0px 0px 0px 10px",
                          borderRadius: "5px",
                          border: "1px solid black",
                        }}
                        onClick={() => {
                          formik.setFieldValue(
                            "memberCount",
                            formik.values.memberCount + 1
                          );
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid> */}

              {formik.values.subDepartment && (
                <Fragment>
                  <MandatoryNote />

                  <LoadingButton
                    disabled={!formikProps.isValid}
                    onClick={() => {
                      formikProps.handleSubmit();
                    }}
                  >
                    Save & Proceed
                  </LoadingButton>
                </Fragment>
              )}
            </Fragment>
          );
        }}
      </Formik>
    </Fragment>
  );
}

export default Form1;
